<template>
    <div class="app flex-row align-items-center">
        <div class="container">
            <b-row class="justify-content-center">
                <b-col md="8">
                    <b-card-group>
                        <b-card no-body class="p-4">
                            <b-card-body>
                                <b-form @submit.prevent="passwordRequest">
                                    <h3 class="mb-4">Wachtwoord vergeten</h3>
                                    <b-input-group class="mb-3">
                                        <b-input-group-prepend><b-input-group-text><i class="icon-user"></i></b-input-group-text></b-input-group-prepend>
                                        <b-form-input type="email" class="form-control" placeholder="E-mail" v-model="form.email" required />
                                    </b-input-group>
                                    <div v-if="loading" class="container-loading mb-3">
                                        <img src="/img/loading.gif" alt="Loading Icon" height="50px">
                                    </div>
                                    <p v-if="message" class="text-success">{{ message }}</p>
                                    <b-row>
                                        <b-col cols="12">
                                            <b-button variant="primary" class="px-4 mt-2" type="submit">Wachtwoord aanvragen</b-button>
                                        </b-col>
                                    </b-row>
                                </b-form>
                            </b-card-body>
                        </b-card>
                        <b-card bg-variant="dark"  class="d-md-down-none d-flex align-items-center" style="background-image: url('/img/logo-rccs.svg'); background-repeat: no-repeat; background-size: 80% auto; background-position: center;"></b-card>
                    </b-card-group>
                </b-col>
            </b-row>
        </div>
    </div>
</template>

<script>
    import axios from 'axios';
    import {addData} from "@/api";

    export default {
        name: 'password-forgot',
        data() {
            return {
                form: {
                    email: null,
                },
                message: null,
                success: false,
                loading: false,
            }
        },
        methods: {
            async passwordRequest() {
                this.loading = true;
                const request = await addData('auth/forgot-password', this.form).then(response => response);
                if (request.status) {
                    this.message = 'Als dit e-mailadres bekend is in ons systeem, dan is er een email gestuurd naar bovenstaand adres met verdere instructies.';
                    this.loading = false;
                }
            }
        },
    }
</script>
